import { FilledButton } from "@/components/ui/buttons/FilledButton";
import { cn } from "@/utils/cn";
import { ButtonHTMLAttributes } from "react";

type OnboardingPillButtonProps = Omit<ButtonHTMLAttributes<HTMLButtonElement>, "color"> & {
  text: string;
};

/** White pill CTA used on the dark v5 onboarding screens ("Button Pill Tall Selectable" in Figma). */
export const OnboardingPillButton = ({ text, className, ...props }: OnboardingPillButtonProps) => (
  <FilledButton
    text={text}
    color="white"
    textCase="normal"
    className={cn(
      "h-[52px] border border-white/15 text-purple-700 shadow-[inset_0px_-12px_12px_0px_rgba(98,10,213,0.12)]",
      "disabled:bg-white/[0.07] disabled:text-white/60 disabled:opacity-100",
      className,
    )}
    {...props}
  />
);
